import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/newRedesign/primitives/Dialog'

import { movimientosColumns } from '../movimientos/Columns'
import { MovimientosDataTable } from '../movimientos/DataTable'
import { MovimientosTableContextProvider } from '../movimientos/TableContext'

interface MovimientosModalProps {
  isOpen: boolean
  onClose: () => void
  loteId: string
  loteName: string
}

export default function MovimientosModal({
  isOpen,
  onClose,
  loteId,
}: MovimientosModalProps) {
  return (
    <Dialog onOpenChange={(open) => !open && onClose()} open={isOpen}>
      <DialogContent
        className="flex h-[800px] max-h-[90vh] w-[1200px] max-w-[95vw] flex-col overflow-hidden rounded-lg p-0"
        style={{
          backgroundColor: '#FAFAFA',
          boxShadow:
            '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Header */}
        <DialogHeader className="flex-shrink-0 border-b border-neutral-300 px-6 py-4">
          <DialogTitle className="text-xl font-semibold text-neutral-900">
            Movimiento de inventario
          </DialogTitle>
        </DialogHeader>

        {/* Content section - must have fixed height and overflow */}
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-6 py-4">
          <MovimientosTableContextProvider loteId={loteId}>
            <MovimientosDataTable columns={movimientosColumns} />
          </MovimientosTableContextProvider>
        </div>
      </DialogContent>
    </Dialog>
  )
}
